import crewing from './crewing'
import transport from './transport'

export default {
  crewing,
  transport
}
